import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowButton } from '@ff-os/shared-react/components/window/partials/WindowButton';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { useCloseWindow } from '@ff-os/shared-react/context/window/useWindowContext';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { SizeAttributeDropdownList } from './SizeAttributeDropdownList';

export const SizeAttributeWindow = ({
    variableIds, hasPreview, renderPreview
}: Props) => {

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const onClose = useCloseWindow(() => setIsOpen(false));

    return (
        <>
            <WindowButton chevron
                icon={!hasPreview ? <Icon type='general-ui-ruler' /> : undefined}
                onClick={() => setIsOpen(true)}>
                {renderPreview()}
            </WindowButton>

            <WindowContext isOpen={isOpen} close={() => setIsOpen}>
                <WindowContext.Header>
                    <WindowHeader previous={onClose}>
                        {t('variables.size')}
                    </WindowHeader>
                </WindowContext.Header>
                <WindowContext.Body>
                    <SizeAttributeDropdownList gap='xs' variableIds={variableIds} />
                </WindowContext.Body>
                <WindowContext.Footer>
                    <WindowFooter justify='end'>
                        <Button onClick={onClose}>
                            {t('commons.save')}
                        </Button>
                    </WindowFooter>
                </WindowContext.Footer>
            </WindowContext>
        </>
    );
};

type Props = {
    hasPreview: boolean;
    renderPreview: () => JSX.Element;
    variableIds: string[];
};